module.exports = __webpack_public_path__ + "static/img/fundo-verde.0afb876.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background/fundo-verde.svg
// module id = Zqeq
// module chunks = 1